<template>
    <div class="accordionTest" v-if="accordion">
        <div class="testScenario">
            <div class="backButton">
                <button @click="goToList"><i class="fas fa-arrow-left-long"></i> Back</button>
            </div>
            <h2>Test Scenario</h2>
            <h4>{{ testScenario.description }}</h4>
            <div class="childObject testScenarioData" v-for="(data, ind) in testScenario.testScenarioData" :key="data.id">
                <button class="deleteButton" @click="deleteTestScenarioData(ind)">
                    <i class="fas fa-trash-can"></i>
                </button>
                <div class="formRow">
                    <div class="dataProp">
                        <p><b>Attribute</b></p>
                        <p>{{ data.attributeCode }}</p>
                        <div class="flexBreak"></div>
                        <p class="attributeCode" v-if="data.attributeCode">{{ getAttributeDescription(data.attributeCode) }}</p>
                        <input style="margin-bottom: 10px;" type="text" v-if="data.attributeCode === 'Other'" v-model="data.customAttributeCode" @blur="getAccordion" />
                    </div>
                    <div class="dataProp">
                        <p><b>Data</b></p>
                        <select v-if="data.questionType === 'SingleSelect'" v-model="data.data" @blur="getAccordion">
                            <option v-for="answer in data.answerValues" :key="answer">{{ answer }}</option>
                        </select>
                        <Multiselect v-else-if="data.questionType === 'MultiSelect'" 
                                v-model="data.data"
                                :options="data.answerValues"
                                placeholder="Type to search"
                                open-direction="bottom"
                                :multiple="true"
                                :searchable="true"
                                @focusout="getAccordion"
                                @remove="getAccordion"></Multiselect>
                        <input v-else type="text" v-model="data.data" @blur="getAccordion" />
                    </div>
                </div>
            </div>
            <ItemModal :itemName="'Scenario Data'"
                        :formRows="testScenarioDataFormRows"
                        :saveItemFunction="saveNewTestScenarioData"
                        :refreshItemsFunction="function(){}"
                        :isActive="true"></ItemModal>
        </div>
        <div class="accordion">
            <h1>{{accordion.name}}</h1>
            <h4>Code: {{accordion.code}}</h4>
            <h3>Headers</h3>
            <div v-for="header in accordion.headers" :key="header.id" class="headerContainer">
                <div class="detailSequence">
                    <h4>Sequence</h4>
                    <p>{{ header.sequence }}</p>
                </div>
                <div class="">
                    <h4>Display Text</h4>
                    <p v-html="header.displayText"></p>
                </div>
            </div>
            <div>
                <h3>Sections</h3>
                <div v-if="accordion && accordion.sections && accordion.sections.length" class="showHideAll">
                    <h4 v-if="!allSectionsExpanded" @click="toggleAllSections()"><i class="fas fa-circle-plus"></i> Show All Details</h4>
                    <h4 v-if="allSectionsExpanded" @click="toggleAllSections()"><i class="fas fa-circle-minus"></i> Hide All Details</h4>
                </div>
            </div>
            <div v-for="section in accordion.sections" :key="section.id" class="sectionContainer">
                <div class="sectionMinimized">
                    <div class="section">
                        <div class="sectionSequence">
                            <p><b>Sequence</b></p>
                            <p>{{ section.sequence }}</p>
                        </div>
                    </div>
                    <div class="sectionHeader" v-for="header in section.headers" :key="header.id">
                        <h4>Header</h4>
                        <div class="headerFieldContainer">
                            <div class="headerTextFields">
                                <div class="headerSequence">
                                    <p><b>Sequence</b></p>
                                    <p>{{ header.sequence }}</p>
                                </div>
                                <div class="headerMininmizedText">
                                    <p><b>Minimized text</b></p>
                                    <p v-html="header.minimizedText"></p>
                                </div>
                                <div class="headerExpandedText">
                                    <p><b>Expanded text</b></p>
                                    <p v-html="header.expandedText"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="showHideDetails">
                        <span v-if="!expandedSections[section.id]" @click="toggleOpen(section)"><i class="fas fa-circle-plus"></i> Show Details</span>
                        <span v-if="expandedSections[section.id]" @click="toggleOpen(section)"><i class="fas fa-circle-minus"></i> Hide Details</span>
                    </div>
                </div>
                <div class="sectionExpanded" v-if="expandedSections[section.id]">
                    <hr/>
                    <span class="subtitle">Details</span>
                    <div v-for="detail in section.details" :key="detail.id" class="detail">
                        <div style="display: flex; flex-direction: column;">
                            <div style="display: flex; flex-direction: row; align-items:center;">
                                <p class="detailHeader">Sequence</p>
                                <p>{{ detail.sequence }}</p>
                            </div>
                        </div>
                        <div class="detailMediaProperty" v-if="detail.mediaProperty">
                            <b class="detailHeader">Media Property</b> <a target="_blank" :href="'/MediaPropertyEdit?ID=' + detail.mediaProperty.id"><i class="fa-solid fa-up-right-from-square fa-xl"></i></a>
                            <div>
                                <p><b>Type:</b> {{ detail.mediaProperty.mediaType }}</p>
                                <p><b>Description:</b> {{ detail.mediaProperty.description }} </p>
                            </div>
                        </div>
                        <div class="flex-break"></div>
                        <div class="detailDisplayText">
                            <b>Display Text</b>
                            <p v-html="detail.displayText"></p>
                        </div>
                    </div>
                </div>
            </div>
            <h3>Footers</h3>
            <div v-for="footer in accordion.footers" :key="footer.id" class="sectionContainer" style="position:relative; flex-wrap:nowrap;">
                <div class="detailSequence">
                    <p><b>Sequence</b></p>
                    <p>{{ footer.sequence }}</p>
                </div>
                <div class="detailDisplayText">
                    <p v-html="footer.displayText"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ItemModal from '@/components/ItemModal.vue';
import Multiselect from 'vue-multiselect';

export default {
    name: 'AccordionTest',
    components: { ItemModal, Multiselect },
    data: function() {
        return {
            accordion: null,
            testScenario: {},
            attributes: [],
            showDeletedElements: false,
            expandedSections: {},
            allSectionsExpanded: false,
            scenarioDataCounter: 0,
            testScenarioDataFormRows: [
            {
                    name: 'Attribute',
                    propertyName: 'attributeCode',
                    element: 'select',
                    required: {
                        propertyName: 'customAttributeCode',
                        equals: true,
                        value: false
                    },
                    selectOptions: []
                },
                {
                    name: 'Other Attribute',
                    propertyName: 'customAttributeCode',
                    required: {
                        propertyName: 'attributeCode',
                        equals: true,
                        value: 'Other'
                    },
                    element: 'input',
                    showIf: {
                        propertyName: 'attributeCode',
                        equals: true,
                        value: 'Other'
                    }
                },
                {
                    name: 'Data',
                    propertyName: 'data',
                    required: true,
                    element: 'input'
                }
            ]
        };
    },
    async mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        this.testScenario = await data.getTestScenario(urlParams.get('testScenarioId'), urlParams.get('testConfigurationId'));
        const testConfiguration = await data.getTestConfiguration(urlParams.get('testConfigurationId'));
        this.attributes = await data.getAllAttributes('', true);
        this.attributes.unshift({code: 'Other'});
        this.testScenarioDataFormRows.find(row => row.propertyName === 'attributeCode').selectOptions = this.attributes.map(att => {return{displayName: att.code, internalName: att.code}});
        if(testConfiguration.survey) {
            this.processSurvey(testConfiguration.survey, this.testScenario);
        }
        await this.getAccordion();
    },
    methods: {
        processSurvey: function(survey, testScenario) {
            survey.pages.forEach(pg => {
                pg.questions.forEach(ques => {
                    if(ques.questionInfo.attribute) {
                        let tsd = testScenario.testScenarioData.find(tsd => tsd.attributeCode === ques.questionInfo.attribute.code);
                        if(tsd) {
                            tsd.questionType = ques.questionInfo.questionType;
                            tsd.answerValues = ques.questionInfo.answers.length ? ques.questionInfo.answers.map(ans => {return ans.answerValue}) : null;
                            if(ques.questionInfo.questionType === 'MultiSelect' && tsd.data)
                                tsd.data = tsd.data.split(',');
                        } else {
                            testScenario.testScenarioData.push({
                                questionType: ques.questionInfo.questionType,
                                attributeCode: ques.questionInfo.attribute.code,
                                answerValues: ques.questionInfo.answers.length ? ques.questionInfo.answers.map(ans => {return ans.answerValue}) : null
                            });
                        }
                    }
                })
            });
        },
        getAccordion: async function() {
            const urlParams = new URLSearchParams(window.location.search);
            let displayParams = {};
            this.testScenario.testScenarioData.forEach(obj => {
                if(obj.data) {
                    if(obj.attributeCode === 'Other')
                        displayParams[obj.customAttributeCode] = obj.data;
                    else
                        displayParams[obj.attributeCode] = obj.data;
                }
            });
            this.accordion = await data.getAccordionWithParameters(urlParams.get('accordionCode'), this.isEmpty(displayParams) ? null : displayParams);
            this.sortAccordion();
        },
        isEmpty: function(obj) {
            for (const prop in obj) {
                if (Object.hasOwn(obj, prop)) {
                    return false;
                }
            }
            return true;
        },
        getAttributeDescription: function(code) {
            let attr = this.attributes.find(att => att.code === code);
            return attr ? attr.description : '';
        },
        sortAccordion: function() {
            this.accordion.sections.sort((a,b) => {return a.sequence - b.sequence});
            this.accordion.headers.sort((a,b) => { return a.sequence - b.sequence});
            this.accordion.footers.sort((a,b) => { return a.sequence - b.sequence});
            this.accordion.sections.forEach(sec => {
                sec.headers.sort((a,b) => {return a.sequence - b.sequence});
                sec.details.sort((a,b) => {return a.sequence - b.sequence});

                sec.details.forEach(detail => { detail.isTitle = (detail.cssClass === 'accordionDetailTitle'); });
            });
        },
        toggleOpen: function(sec) {
            if(!this.expandedSections[sec.id])
                this.expandedSections[sec.id] = false;
            else {
                sec.details.forEach(det => {
                    det.showConditionalJson = false;
                    det.showDisplayText = false;
                });
            }
                
            this.expandedSections[sec.id] = !this.expandedSections[sec.id];
        },
        toggleAllSections: function() {
            if(!this.allSectionsExpanded) {
                for(let i = 0; i < this.accordion.sections.length; i++) {
                    this.expandedSections[this.accordion.sections[i].id] = true;
                }
                this.allSectionsExpanded = true;
            } else {
                const expandedSections = this.expandedSections;
                this.accordion.sections.forEach(sec => {
                    if(expandedSections[sec.id]) {
                        sec.details.forEach(det => {
                            det.showConditionalJson = false;
                            det.showDisplayText = false;
                        })
                    }
                })
                this.expandedSections = {};
                this.allSectionsExpanded = false;
            }
        },
        saveNewTestScenarioData: function(tsd) {
            let newTsd = {
                attributeCode: tsd.attributeCode,
                customAttributeCode: tsd.customAttributeCode,
                data: tsd.data,
                id: this.scenarioDataCounter
            };
            this.scenarioDataCounter--;
            this.testScenario.testScenarioData.push(newTsd);
            this.getAccordion();
            return {success: true};
        },
        deleteTestScenarioData: function(ind) {
            if(this.testScenario.testScenarioData[ind].attributeCode === 'Other')
                this.testScenario.testScenarioData.splice(ind, 1);
            else
                this.testScenario.testScenarioData[ind].data = null;
            this.getAccordion();
        }
    }
}
</script>

<style scoped>
    .accordionTest {
        width: 100%;
        display: flex;
        max-height: calc(100vh - 60px);
    }
    .testScenario {
        width: 40%;
        border-right: 1px solid darkgray;
        padding-right: 10px;
        overflow-y: auto;
    }
    .testScenario input {
        width: 96%;
    }
    .testScenarioData {
        position: relative;
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
        padding: 0 10px;
    }
    .dataProp {
        display: flex;
        flex-direction: column;
        padding: 5px;
        width: 48%;
    }
    .accordion {
        width: 60%;
        padding-left: 10px;
        overflow-y: auto;
    }
    .headerContainer {
        text-align: left;
        min-height: 200px;
        width: 95%;
        padding: 10px;
        border: 1px solid #f0f0f0;
        background-color: #f0f0f0;
        border-radius: 20px;
        margin-bottom: 20px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column; 
    }
    .sectionContainer {
        text-align: left;
        min-height: 200px;
        width: 95%;
        padding: 10px;
        border: 1px solid #f0f0f0;
        background-color: #f0f0f0;
        border-radius: 20px;
        margin-bottom: 20px;
        display: flex;
        flex-wrap: wrap;
    }
    .sectionMinimized {
        display: flex;
        flex: 1 1 100%;
        align-items: center;
        margin-bottom: 20px;
        position: relative;
        align-self: stretch;
        flex-direction: column;
    }
    .section {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        align-self: stretch;
        align-items: center;
        padding: 0 20px;
    }
    .sectionSequence {
        padding-left: 20px;
        flex: 0 0 80px;
    }
    .sectionSequence input {
        width: 50px;
    }
    .sectionHeader {
        border: 1px solid lightgray;
        border-radius: 20px;
        background-color: lightgray;
        padding: 0 20px;
        margin: 0 10px;
        position: relative;
        width: 90%;
    }
    .headerFieldContainer {
        display: flex;
        justify-content: center;
        width: 100%;
    }
    .headerSequence {
        flex: 0 0 100px;
    }
    .headerTextFields {
        margin-right: 40px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }
    .headerMininmizedText, .headerExpandedText {
        flex: 1 1 150px;
    }
    .showHideAll {
        cursor: pointer;
    }
    .showHideDetails {
        cursor: pointer;
        width: 100%;
        margin: 20px 0 0 20px;
    }
    .sectionExpanded {
        margin: 0 10px;
        flex: 1 1 100%;
    }
    .detail {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        border-top: 1px solid lightgray;
        margin: 10px 0;
        border: 1px solid lightgray;
        border-radius: 20px;
        background-color: lightgray;
        padding: 13px;
    }
    .detailSequence input {
        width: 50px;
    }
    .detailMediaProperty {
        flex: 1 1 300px;
        padding: 0 10px;
        margin-left: 20px;
        margin-top: 10px;
    }
    .detailMediaProperty span {
        display: inline-block;
        margin: 16px 20px 16px 0;
    }
    .detailDisplayText {
        flex: 1 1 700px;
        padding-right: 20px;
    }
    .detailHeader {
        font-weight: bold;
        width: 120px;
        text-align: left;
    }
    .deleteButton {
        position: absolute;
        width: 40px;
        height: 40px;
        background-color: darkred;
        border-color: darkred;
        color: white;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        right: 5px;
        top: 5px;
        z-index: 50;
    }
</style>